import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "dana",
    subtitle1: {
      fontSize: 14,
      fontWeight: "normal",
    },
  },
  palette: {
    primary: {
      main: "#1E91C2",
    },
    // secondary: {
    //   main: "#881553",
    //   dark: "#881553",
    // },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*": {
          "scrollbar-width": "thin",
        },
        "*::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
      },
    },
    MUIDataTableBody: {
      root: { backgroundColor: "blue", height: "90%" },
    },
  },
});
